let $ = require("jquery");
let _ = require("underscore");
let Backbone = require("backbone");
import POS from "../../POS.js";

let main = function () {
    return Backbone.View.extend({
        currencyCredit: 0,
        events: {
            'click .currency-type': 'chooseCurrency',
            'click .confirm-currency': 'currencyPay'
        },
        initialize: function () {
            var currency = this.$(".currenciesMode .currency-type.selected");
            if (currency.length > 0) {
                this._changeBillInfo(currency);
            }
        },
        currencyPay: function () {
            var chooseCurrencyId = this.$(".currenciesMode .currency-type.selected").data('id');
            this.model.set({
                creditEnough: this.model.get("creditEnough"),
                currencyCredit: this.currencyCredit,
                currency: this.options.supportCurrencies.find(function (c) {
                    return c.id == chooseCurrencyId
                }),
                membershipPay: true,
                currencyId: chooseCurrencyId,
                basicPay: this.$(".currenciesMode .currency-type.selected").data('type') == 'BASIC',
                membershipPayment: this.$(".currency-shouldPay").text()
            });
        },
        chooseCurrency: function (evt) {
            var currency = $(evt.currentTarget);
            currency.addClass("selected").siblings(".currency-type").removeClass("selected");
            this._changeBillInfo(currency);
        },
        _changeBillInfo: function (currency, credit) {
            var rechargeRatio = currency.data("rule"), currencyId = currency.data('id'), type = currency.data('type'),
                currencyCredit = 0, currencyShouldPay = 0;
            _.each(this.options.membership.credit, function (credit) {
                if (credit.id == currencyId) {
                    currencyCredit = credit.credit;
                }
            });
            this.currencyCredit = currencyCredit;
            this.$(".currency-credit").text(currencyCredit);
            if (type == 'BASIC') {
                _.each(this.options.items, function (item, index) {
                    var menuItem = POS.get('menuItemBytesmap')[item.menuItem.id];
                    var currencyPrice = 0;
                    if (menuItem.currencyPrices && menuItem.currencyPrices.value.length > 0) {
                        _.each(menuItem.currencyPrices.value, function (cp) {
                            if (cp.currencyId == currencyId) {
                                currencyPrice = cp.currencyPrice;
                            }
                        });
                    }
                    if (currencyPrice > 0) {
                        currencyShouldPay += parseFloat(currencyPrice) * parseInt(item.orderedQuantity);
                        return;
                    }
                    currencyShouldPay += (parseInt(item.orderedQuantity) * parseFloat(item.price)) * rechargeRatio;
                });
                this.$(".currency-shouldPay").text(currencyShouldPay);
                if (currencyCredit >= currencyShouldPay) {
                    this.model.set({
                        "creditEnough": true
                    });
                    this.$(".help-block").addClass("hidden");
                    this.$(".confirm-currency").attr("disabled", false);
                } else {
                    this.model.set({
                        "creditEnough": false
                    });
                    this.$(".help-block").removeClass("hidden");
                    this.$(".confirm-currency").attr("disabled", true);
                }
            } else {
                currencyShouldPay = this.options.shouldPay * rechargeRatio;
                this.$(".currency-shouldPay").text(currencyShouldPay);
            }
        }
    });
};

let exportedValue = main();
export default exportedValue;


// WEBPACK FOOTER //
// ./src/view/cashier/CurrencySelectorView.js